/**
 * SecuredByAiLink — "24/7 Secured by AI" trust badge that opens the Safety &
 * Privacy page. The sidebar carries the labelled row; below 1024px the sidebar
 * collapses to a tab bar and drops it, so the WLB feed header shows the shield
 * on its own instead. Each variant hides itself where the other one shows.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import shieldImage from '../../assets/images/sidebar-shield-ai.webp';
import './layout.css';

interface SecuredByAiLinkProps {
  /** `rail`: labelled sidebar row. `compact`: icon-only badge for the feed header. */
  variant: 'rail' | 'compact';
}

export function SecuredByAiLink({ variant }: SecuredByAiLinkProps) {
  const { t } = useTranslation();
  const tooltip = t('sidebar.securedByAi.tooltip');

  return (
    <Link
      to="/support/privacy"
      className={`secured-badge secured-badge--${variant}`}
      title={tooltip}
      // The labelled variant already names itself; overriding it there would
      // leave the accessible name without the text on screen.
      aria-label={variant === 'compact' ? tooltip : undefined}
    >
      <img className="secured-badge__icon" src={shieldImage} alt="" aria-hidden />
      {variant === 'rail' && <span>{t('sidebar.securedByAi.label')}</span>}
    </Link>
  );
}
